// require("./lib/pym");
require("./analytics");
var $ = require("./lib/qsa");
var debounce = require("./lib/debounce");

var cells = $(".fixed-grid .cell");

var highlighted = null;
var highlightStage = function(element) {
  if (highlighted == element) return;
  highlighted = element;
  var gridItems = element.dataset.items.split(/,\s*/);
  var gridSet = new Set(gridItems);
  cells.forEach(function(c) {
    c.classList.toggle("dimmed", !gridSet.has(c.dataset.key));
  });
};

var unhighlight = function() {
  highlighted = null;
  cells.forEach(c => c.classList.add("dimmed"));
};

var activated = null;
var activateStage = function(element) {
  if (activated == element) return;
  deactivate();
  activated = element;
  element.classList.add("active");
};

var deactivate = function() {
  if (!activated) return;
  activated.classList.remove("active");
  activated = null;
};

var stages = $(".stage").reverse();
var threshold = .9;
var onScroll = function() {
  for (var i = 0; i < stages.length; i++) {
    var stage = stages[i];
    var bounds = stage.getBoundingClientRect();
    if (bounds.top < window.innerHeight * threshold && bounds.bottom > 0) {
      if (stage.dataset.items) {
        deactivate();
        return highlightStage(stage);
      } else {
        unhighlight();
        return activateStage(stage);
      }
    }
  }
  unhighlight();
  deactivate();
};

onScroll = debounce(onScroll);

window.addEventListener("scroll", onScroll);
window.addEventListener("resize", onScroll);
onScroll();